import { UserListQuery } from "@common/model/interface/user";
import {
  getAccessTokenApi,
  checkTokenExpiredApi,
  getUserIdsListApi,
  loginOutApi,
  getUserInfoByTokenApi,
  getAccountInfoApi,
  getUserPerimissionsApi,
  getUserNameByTokenApi,
  getUserTenantApi
} from "@common/api/user/user";

export default class UserService {
  static request;

  static setRequest(request) {
    this.request = request;
  }
  // 获取accessToken
  static getAccessToken(data) {
    return getAccessTokenApi(UserService.request, data);
  }

  // accessToken是否失效
  static checkTokenExpired(data) {
    return checkTokenExpiredApi(UserService.request, data);
  }

  // 根据用户id/id集合获取用户信息/列表信息
  static getUserIdsList(data: UserListQuery) {
    return getUserIdsListApi(UserService.request, data);
  }

  // 根据token获取用户信息
  static getUserInfoByToken() {
    return getUserInfoByTokenApi(UserService.request);
  }
  static getUserNameByTokenApi() {
    return getUserNameByTokenApi(UserService.request);
  }
  // 获取个人账号信息
  static getAccountInfo() {
    return getAccountInfoApi(UserService.request);
  }

  // 获取个人权限
  static getUserPerimissions() {
    return getUserPerimissionsApi(UserService.request);
  }

  // 获取租户管理员列表(primaryAccount-->0:没有所属租户的账号 + 该组织下的主账号列表; 1:主账号; 2:除平台管理员外的所有账号)
  static getUserTenant(query) {
    return getUserTenantApi(UserService.request, query);
  }

  // 退出登录
  static loginOut() {
    return loginOutApi(UserService.request);
  }
}
